<template>
    <div class="logo-left">
        <router-link to="/" class="logo">
            <img src="../../assets/images/white-logo.svg" alt="Logo">
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "Logo"
    }
</script>

<style scoped>

</style>